import { isNil } from 'lodash-es';

type TMetaPixelParams = Record<string, unknown>;

type TFbq = (command: string, eventName: string, params?: TMetaPixelParams) => void;

const getFbq = (): TFbq | null => {
	if (typeof window === 'undefined') {
		return null;
	}

	const fbq = (window as unknown as { fbq?: TFbq }).fbq;

	return typeof fbq === 'function' ? fbq : null;
};

export const trackMetaPixelEvent = (eventName: string, params?: TMetaPixelParams): void => {
	const fbq = getFbq();

	if (!fbq) {
		return;
	}

	if (isNil(params)) {
		fbq('track', eventName);
		return;
	}

	fbq('track', eventName, params);
};

export const trackMetaPixelPageView = (): void => {
	trackMetaPixelEvent('PageView');
};
